
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.543 6.989C3.112 8.633 5.333 12 10.5 12c5.242 0 7.428-3.164 7.964-4.99C17.918 5.283 15.71 2 10.5 2 5.31 2 3.1 5.256 2.543 6.989zM.53 6.757C1.119 4.402 3.955 0 10.5 0c6.545 0 9.381 4.402 9.97 6.757l.058.234-.054.234C19.884 9.785 17.024 14 10.5 14 3.92 14 1.12 9.41.535 7.263l-.069-.252.064-.254z"}}),_c('path',{attrs:{"d":"M10.5 6a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0z"}})])
          )
        }
      }
    